const prefix = '@@MISSING_CHANNELS_MODAL';

export const OPEN_MODAL = `${prefix}__OPEN_MODAL`;
export const CLOSE_MODAL = `${prefix}__CLOSE_MODAL`;
